import auth_en_US from './en_US/auth.json';
import cart_en_US from './en_US/cart.json';
import checkout_en_US from './en_US/checkout.json';
import common_en_US from './en_US/common.json';
import instant_ink_en_US from './en_US/instant-ink.json';
import order_en_US from './en_US/order.json';
import pdp_config_en_US from './en_US/pdp-config.json';
import review_subscription_en_US from './en_US/review-subscription.json';
import common_pt_BR from './pt_BR/common.json';

export enum LanguagesI18n {
  EN_US = 'en_US',
  PT_BR = 'pt_BR',
}

export enum NamespacesI18n {
  AUTH = 'auth',
  COMMON = 'common',
  CART = 'cart',
  CHECKOUT = 'checkout',
  ORDER = 'order',
  PDP_CONFIG = 'pdp_config',
  REVIEW_SUBSCRIPTION = 'review_subscription',
  INSTANT_INK = 'instant_ink',
}

export const resourcesApp: Record<
  LanguagesI18n,
  Partial<Record<NamespacesI18n, unknown>>
> = {
  [LanguagesI18n.EN_US]: {
    [NamespacesI18n.AUTH]: auth_en_US,
    [NamespacesI18n.COMMON]: common_en_US,
    [NamespacesI18n.CART]: cart_en_US,
    [NamespacesI18n.CHECKOUT]: checkout_en_US,
    [NamespacesI18n.ORDER]: order_en_US,
    [NamespacesI18n.PDP_CONFIG]: pdp_config_en_US,
    [NamespacesI18n.REVIEW_SUBSCRIPTION]: review_subscription_en_US,
    [NamespacesI18n.INSTANT_INK]: instant_ink_en_US,
  },
  [LanguagesI18n.PT_BR]: {
    [NamespacesI18n.COMMON]: common_pt_BR,
  },
} as const;
